import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.has('Authorization')) {
            return next.handle(req);
        }

        const Authorization = 'Bearer ' + this.authService.getAccessToken();

        let accessControlHeader = new HttpHeaders();
   //     accessControlHeader = new HttpHeaders({ 'Access-Control-Allow-origin': environment.loginEndPoint });
   //     accessControlHeader = new HttpHeaders({ 'Access-Control-Allow-origin': "https://agricoltura-coll.regione.lazio.it/" });

        const clonedReq = req.clone({
            setHeaders: { Authorization },
            headers: accessControlHeader
        });

        return next.handle(clonedReq);
    }
}
